import { render, staticRenderFns } from "./availability-restrictions.vue?vue&type=template&id=3a054b06"
import script from "./availability-restrictions.vue?vue&type=script&lang=js"
export * from "./availability-restrictions.vue?vue&type=script&lang=js"
import style0 from "./availability-restrictions.vue?vue&type=style&index=0&id=3a054b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports